<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>

            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Modify Leave Approval</v-toolbar-title>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="3">
                        <p><v-icon color="error">*</v-icon><b>Leave Academic Year</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list"
                            item-text="ay" item-value="id" return-object label="Leave Academic Year" outlined readonly
                            persistent-hint hint="Please Select Leave Academic Year" />
                    </v-col>
                    <v-col cols="12" sm="3">
                        <p><v-icon color="error">*</v-icon><b>Leave Type</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="leave_type"
                            :items="leave_type_list" item-text="type" item-value="id" label="Leave Type" outlined
                            persistent-hint hint="Please Select Leave Type" />
                    </v-col>
                    <v-col cols="12" sm="3">
                        <p><v-icon color="error">*</v-icon><b>Leave Approval Status</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="leave_approval_status"
                            :items="leave_approval_status_list" item-text="status" item-value="id"
                            label="Leave Approval Status" outlined persistent-hint
                            hint="Please Select Leave Approval Status" />
                    </v-col>
                </v-row>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="3">
                        <p><v-icon color="error">*</v-icon><b>From Date</b></p>
                        <v-menu v-model="menu11" :close-on-content-click="false" :nudge-right="40"
                            transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field persistent-hint hint="YYYY/MM/DD FORMAT INCLUSIVE" placeholder="Inclusive"
                                    color="#0F2027" v-model="date_1" outlined rounded dense label="From Date"
                                    prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="date_1" @input="menu11 = false"></v-date-picker>
                        </v-menu>
                        <!-- <input id="datePickerId" type="date" v-model="date_1" /> -->
                    </v-col>
                    <v-col cols="12" sm="3">
                        <p><v-icon color="error">*</v-icon><b>To Date</b></p>
                        <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                            transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field color="#0F2027" persistent-hint hint="YYYY/MM/DD FORMAT EXCLUSIVE"
                                    placeholder="Exclusive" v-model="date_2" outlined rounded dense label="To Date"
                                    prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                            </template>
                            <v-date-picker :min="date_1" v-model="date_2" @input="menu2 = false"></v-date-picker>
                        </v-menu>
                        <!-- <input id="datePickerId" type="date" v-model="date_2" /> -->
                    </v-col>
                    <v-col cols="12" sm="3">
                        <p><v-icon color="error">*</v-icon><b>Instructor</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="instructor"
                            :items="instructor_list" item-text="name" item-value="id" label="Instructor" outlined
                            persistent-hint hint="Please Select Instructor" />
                    </v-col>
                </v-row>
                <v-row justify="center" dense
                    v-if="ay != '' && leave_type != '' && leave_approval_status != '' && date_1 != '' && date_2 != '' && instructor != ''">
                    <v-btn class="button" @click="fetch()" :loading="loader">Fetch</v-btn>
                </v-row>
            </v-card>
        </v-container>
        <v-card class="box" v-if="this.transactions != ''">
            <v-data-table class="mytable elevation-1" dense :headers="headers" :items="transactions">
                <template v-slot:top>
                    <v-toolbar flat dense class="toolbar">
                        <v-toolbar-title>Transactions</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <br>
                </template>
                <template v-slot:[`item.leaveapprovalstatus`]="{ item }">
                    <v-btn class="ma-2" tile outlined color="success" @click="showdetails(item)"> <v-icon
                            left>mdi-arrow-right-bold-circle-outline</v-icon> Details</v-btn>
                </template>
                <template v-slot:[`item.modify`]="{ item }">
                    <v-btn class="ma-2" tile outlined color="success" @click="editItem(item)"> <v-icon left
                            class="mr-2 edit-v-icon">mdi-pencil</v-icon> Modify</v-btn>
                </template>
                <template v-slot:[`item.cancel`]="{ item }">
                    <v-btn outlined rounded @click="cancelLeaveApproval(item)">Cancel</v-btn>
                </template>
            </v-data-table>
        </v-card>
        <v-dialog v-model="dialog_modify" max-width="1000px">
            <v-card class="card-container">
                <v-card class="box">
                    <v-toolbar class="toolbar" flat dense>
                        <v-toolbar-title>
                            <strong>
                                Modify Leave
                            </strong>
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-row justify="center" dense>
                            <v-col cols="12" sm="3">
                                <p><b>From Date</b></p>
                                <v-text-field persistent-hint readonly color="#0F2027" v-model="edit_item.from_date"
                                    outlined rounded dense label="From Date" prepend-icon="mdi-calendar"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <p><b>To Date</b></p>
                                <v-text-field readonly persistent-hint color="#0F2027" v-model="edit_item.to_date"
                                    outlined rounded dense label="To Date" prepend-icon="mdi-calendar"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="2">
                                <p><b> Reduce No Of Days</b></p>
                                <v-text-field outlined dense type="number"
                                    v-model="edit_item.numberofdays"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <br>
                                <v-btn class="button" @click="updateEmployeeLeave()">Update</v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="button" @click="dialog_modify= false">Close</v-btn>
                    </v-card-actions>
                </v-card>
            </v-card>
        </v-dialog>
        <v-row justify="center" dense v-if="emp_approval_details.length > 0">
            <v-dialog v-model="dialog_showdetails" persistent max-width="1500">
                <v-card>
                    <v-col cols="12" sm="12" md="12">
                        <v-card class="box">
                            <v-toolbar flat dense class="toolbar">
                                <v-toolbar-title>Leave Details</v-toolbar-title>
                            </v-toolbar>
                            <v-col cols="12" sm="12" md="12">
                                <v-simple-table dense class="elevation-1">
                                    <thead>
                                        <tr>
                                            <td>From Date</td>
                                            <td>To Date</td>
                                            <td>Application Date</td>
                                            <td>Number Of Days</td>
                                            <td>Number Of Hours</td>
                                            <td>Reason</td>
                                            <td>Is Load Adjustment Done</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{{emp_approval_details[0].fromdate}}</td>
                                            <td>{{emp_approval_details[0].todate}}</td>
                                            <td>{{emp_approval_details[0].application_date}}</td>
                                            <td>{{emp_approval_details[0].numberofdays}}</td>
                                            <td>{{emp_approval_details[0].number_of_hours}}</td>
                                            <td>{{emp_approval_details[0].reason}}</td>
                                            <td>
                                                <span v-if="emp_approval_details[0].is_load_adjustment_done">YES</span>
                                                <span v-else>NO</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-col>
                            <v-col cols="12" sm="12" md="12">
                                <v-simple-table dense class="elevation-1">
                                    <thead>
                                        <tr>
                                            <td>Alternate Arrangement Person Name</td>
                                            <td>Alternate Arrangement Person Contact Number</td>
                                            <td>Nature Of Work</td>
                                            <td>Place Of Work</td>
                                            <td>Email</td>
                                            <td>Mobile</td>
                                            <td>Medical Certificate / Other Document</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{{emp_approval_details[0].alternate_arragement_person_name}}</td>
                                            <td>{{emp_approval_details[0].alternate_arragement_person_no}}</td>
                                            <td>{{emp_approval_details[0].nature_of_work}}</td>
                                            <td>{{emp_approval_details[0].place_of_work}}</td>
                                            <td>{{emp_approval_details[0].email}}</td>
                                            <td>{{emp_approval_details[0].contact_phone_number}}</td>
                                            <td>
                                                <span v-if="emp_approval_details[0].certificate_file_name != 'NA'">
                                                    <a class="p-2"
                                                        :href="aws_path+emp_approval_details[0].filepath+emp_approval_details[0].filename"
                                                        target="blank">
                                                        <v-tooltip top>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn icon v-bind="attrs" v-on="on"> <v-icon
                                                                        color="black">mdi-eye</v-icon></v-btn>
                                                            </template>
                                                            <span>
                                                                View Certificate / Other Document File!!!
                                                            </span>
                                                        </v-tooltip>
                                                    </a>
                                                </span>
                                                <span v-else>
                                                    {{emp_approval_details[0].certificate_file_name}}
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-col>
                            <v-col cols="12" sm="12" md="12">
                                <v-data-table :headers="headers1" :items="emp_approval_details[0].emp_approval"
                                    class="mytable elevation-1" dense>
                                </v-data-table>
                            </v-col>
                        </v-card>
                    </v-col>
                    <v-row justify="center" dense>
                        <v-btn class="button" @click="dialog_showdetails = false">Close</v-btn>
                    </v-row>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>
<script>
 import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
        data: () => ({
            transactions:[],
            loader: false,
            snackbar_msg: "",
            // extraBreadcrumbItems: [


            // ],
            // breadcrumbClass: "breadcrumb-style1",
            color: "",
            snackbar: false,
            title: "",
            description: "",
            leaves_list: null,
            leave_type_list: null,
            leave_type: null,
            ay_list: [],
            ay: "",
            leave_approval_status_list: null,
            leave_approval_status: null,
            instructor_list: null,
            instructor: null,
            date_1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            modal_1: false,
            date_2: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1)).toISOString().substr(0, 10),
            modal_2: false,
            menu: false,
            menu2: false,
            menu1: false,
            dialog:false,
            dialog_showdetails:false,emp_approval_details:[],
            menu11: false,
            menu_edit_from: false, menu_edit_to: false,
            leave_approval_status_details_list: [],
            emp_leave_approval_transaction_list: [],
            employee_leave_approved_details_list:[],
            emp_approval_details:[],month_transaction_count:'',
            aws_path:null,dialog_modify:false,
             headers:[
                { text: "Sr No", value: "count" },
                { text: "Employee", value: "instructor" },
                { text: "Leave Type", value: "leavetype" },
                { text: "Application Date", value: "application_date" },
                { text: "From Date", value: "fromdate" },
                { text: "To Date", value: "todate" },
                { text: "Days", value: "numberofdays" },
                { text: "Status", value: "leaveapprovalstatus" },
                { text: "Modify", value: "modify" },
                { text: "Cancel", value: "cancel" },
      ],
       headers1 : [
                { text: "Sr. No", value: "srno" , sortable: false, },
                { text: "Authority", value: "authority" , sortable: false, },
                { text: "Authority Name", value: "authority_name" , sortable: false, },
                { text: "Date Of Application", value: "application_push_date" , sortable: false, },
                { text: "Date Of Approval", value: "application_action_date" , sortable: false, },
                { text: "Status", value: "status" , sortable: false, },
                { text: "Remark", value: "remark" , sortable: false, },
            ],
       edit_item:{
          numberofdays:"",from_date:"",to_date:"",id:""}
     }),
       methods: {
            showdetails(item){
                this.dialog_showdetails = true
                const formData = {
                    emp_leave_transaction_id:item.id
                }
                axios
                    .post("/LeaveManagement/getEmployeeLeaveDetails", formData)
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                           this.emp_approval_details = res.data.emp_transaction_list
                           this.aws_path = res.data.aws_path,
                           this.dialog_showdetails=true
                        }
                    })
                    .catch((error) => {
                         this.showSnackbar("#b71c1c", "Something Went Wrong..."); // show snackbar
                    })
                    .finally(() => {
                       // this.dialog_showdetails = false
                    });
            },
           cancelLeaveApproval(item){
                this.loader = true;
                const formData = {
                    leave_transaction_id: item.id,
                }
                axios
                    .post("/LeaveManagement/cancelLeaveApproval", formData)
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                          //  this.transactions=res.data.transactions,
                            this.loader = false;
                            this.showSnackbar("#4caf50", "Leave Cancelled Successfully...!");
                            this.transactions=[]
                        } else if(res.data.flag == "No"){
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            this.loader = false;
                        }
                    })
                    .catch((error) => {
                         this.showSnackbar("#b71c1c", "Something Went Wrong..."); // show snackbar
                    })
                    .finally(() => {
                        this.loader = false;
                        this.fetch();
                    });
           },
           updateEmployeeLeave(){
                this.loader = true;
                axios
                    .post("/LeaveManagement/updateEmployeeLeave", this.edit_item)
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                           // this.transactions=res.data.transactions,
                            this.loader = false;
                            this.dialog_modify=false
                            this.showSnackbar("#4caf50", "Leave Modified Successfully...!");
                             this.fetch();
                        } else if(res.data.flag == "No"){
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            this.loader = false;
                        }
                    })
                    .catch((error) => {
                         this.showSnackbar("#b71c1c", "Something Went Wrong..."); // show snackbar
                    })
                    .finally(() => {
                        this.loader = false;
                        this.dialog_modify=false
                        this.fetch();       
                    });
           },
            editItem(item){
                this.dialog_modify=true
                this.edit_item.id=item.id
                this.edit_item.from_date=item.fromdate
                this.edit_item.to_date=item.todate
                this.edit_item.numberofdays=item.numberofdays
            },
           fetch(){
                this.loader = true;
                const formData = {
                    ay: this.ay,
                    leave_type: this.leave_type,
                    leave_approval_status: this.leave_approval_status,
                    instructor: this.instructor,
                    fromdate: this.date_1,
                    todate: this.date_2,
                };
                axios
                    .post("/LeaveManagement/fetchLeaveApprovedData", formData)
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                            this.transactions=res.data.transactions,
                            this.loader = false;
                        } else if(res.data.flag == "No"){
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            this.loader = false;
                        }
                    })
                    .catch((error) => {
                         this.showSnackbar("#b71c1c", "Something Went Wrong..."); // show snackbar
                    })
                    .finally(() => {
                        this.loader = false;
                    });
           },
             onLoad() {
                const data = {
                    org: null,
                }
                axios
                    .post("/LeaveManagement/getLeaveApprovalData", data)
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                            (this.ay_list = res.data.leaveAcademicYearlist),(this.ay=res.data.leaveAcademicYear), (this.leave_type_list = res.data.leave_type_list),
                            (this.leave_approval_status_list = res.data.leave_approval_status), (this.instructor_list = res.data.instructor_list),(this.leave_approval_status=res.data.leave_approval_status_id)
                        } else {
                            this.showSnackbar("#b71c1c", "Wrong information");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong..."); // show snackbar
                    })
                    .finally(() => {
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
             calculateDays(){
         this.loader=true
         const formData = {
                   date_1:this.edit_item.from_date,
                   date_2:this.edit_item.to_date
                };
         axios
        .post("/LeaveManagement/calculateDays",formData)
        .then((res) => {
            if (res.data.flag == "Yes") {
                this.loader=false
                this.edit_item.numberofdays=res.data.noOfDaysBetween              
        } else {
            //   window.console.log(res.data.msg);
            this.showSnackbar("#b71c1c", "Something went wrong!");
             this.loader=false
        }
    })
    .catch((error) => {
        window.console.log(error);
    })
    .finally(() => {
         this.loader=false
    });
       },
       },
        mounted() {
            this.onLoad();
        },
        watch: {},
    };
</script>
<style scoped>
    input[type="text"] {
        width: 100%;
        display: inline-block;
        border: 1px solid black;
        border-radius: 4px;
        box-sizing: border-box;
    }
    .select {
        width: 100%;
        display: inline-block;
        border: 1px solid black;
        border-radius: 4px;
        box-sizing: border-box;
    }
    input[type="date"] {
        width: 50%;
        display: inline-block;
        padding: 0.3rem;
        border: 1px solid gray;
        border-radius: 30px;
        box-sizing: border-box;
        padding-top: none !important;
        margin-top: none !important;
    }
     tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }
    .table-head-background {
        background-color: #fcc96f;
        color: #fff;
        font-weight: 700;
    }
    .tc-title {
        background-image: linear-gradient(-90deg, #fcc96f, #fcb63c);
        color: #fff;
        font-weight: 700;
        margin: 0px !important;
        padding: 0px !important;
    }
    .text-left {
        font-size: 14px;
        font-weight: bold;
    }
    .text {
        color: blue;
        font-weight: 600;
        font-size: 14px;
    }
    .mytable /deep/ thead th {
        background: #0f2027; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027); /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
     .card-container {
        overflow-x: hidden;
        overflow: hidden;
    }

    
</style>
